import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode'; // npm i jwt-decode

interface DecodedJwt {
  exp: number;
}

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor() { }

  /**
   * Return true if JSON Web Token has a valid structure
   * @param jwt JSON Web Token string
   */
  isValid(jwt: string | null): boolean {
    if(jwt === null || typeof jwt  === undefined){
      return false;
    }
    try {
      const decode:any = jwt_decode(jwt);
      return decode.exp * 1000 > Date.now();
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  /**
   * Return true if JSON Web Token expired
   * @param jwt Valid JSON Web Token string
   */
  isExpired(jwt: string): boolean {
    const decoded: DecodedJwt = jwt_decode(jwt);
    if (Date.now() >= decoded.exp * 1000) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Return data structure from payload
   * @param jwt Valid JSON Web Token string
   * @param dataName Node that contains the data. OPTIONAL
   */
  getData(jwt: string, dataName?: string | undefined): any {
    if (dataName === undefined) {
      dataName = 'data';
    }
    const decoded:any = jwt_decode(jwt);
    return decoded[dataName];
  }
}
